import './polyfills';
import * as React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from 'react-redux';
import { ReduxRouter } from '@lagunovsky/redux-react-router';
//import { BrowserRouter } from 'react-router-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';
import buildFontAwesomeLibrary from './buildFontAwesomeLibrary';
import { store } from './store';
import { history } from './lib/history';
import { unregister } from './registerServiceWorker';

buildFontAwesomeLibrary();

const rootElement = document.getElementById('root');

if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
        <Provider store={store}>
            <ReduxRouter history={history}>
                <App />
            </ReduxRouter>
        </Provider>
    );
}
unregister();
